import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    providers: []
})
export class NavbarComponent implements OnInit {

    activeRoute: string = '';

    constructor(
        private router: Router
    ) {
        this.router.events
            .subscribe((event) => {
                this.activeRoute = this.router.url; // Get current route
            });
    }

    ngOnInit() {
    }

    isActive(route: string): boolean {
        return this.activeRoute === route;
    }

}